const extendControlsFontFamily = {
  key: "font-family"
};
const fontFamily = [
  {
    name: "\u5B8B\u4F53",
    family: '"\u5B8B\u4F53",sans-serif'
  },
  {
    name: "Araial",
    family: "Arial, Helvetica, sans-serif"
  },
  {
    name: "Georgia",
    family: "Georgia, serif"
  },
  {
    name: "Impact",
    family: "Impact, serif"
  },
  {
    name: "Monospace",
    family: '"Courier New", Courier, monospace'
  },
  {
    name: "Tahoma",
    family: 'tahoma, arial, "Hiragino Sans GB", \u5B8B\u4F53, sans-serif'
  },
  {
    name: "\u9ED1\u4F53",
    family: '"\u9ED1\u4F53",serif'
  },
  {
    name: "\u6977\u4F53",
    family: "\u6977\u4F53"
  },
  {
    name: "\u5E7C\u5706",
    family: "YouYuan"
  }
];
export {fontFamily, extendControlsFontFamily};
